import React from 'react';

function GiftMain({}) {
    return (
        <div>
            <h1>Gift Page</h1>
        </div>
    );
}

export default GiftMain;